import Footer from '@/next/components/Footer/Footer';

export default Footer;
